
import milari from "../../assets/images/milari.png";
import easify from "../../assets/images/easiffy.jpg";
import greenvalley from "../../assets/images/greenvalley.jpg";
import operandi from "../../assets/images/operandi2.png.jpg";
import vegananatura from "../../assets/images/vegananatura.png";
import shlomit from "../../assets/images/shlomit.jpg";
import ratnalinga from "../../assets/images/ratna.jpg";
import cannabiz from "../../assets/images/cannabiz.jpg";
import aamir from "../../assets/images/aamir.jpg";
// import digitalhp from "../../assets/images/digitalhp.jpg";
import ecom from "../../assets/images/ecom.jpg";
import visapro from "../../assets/images/visapro.jpg";
import accidentmate from "../../assets/images/accidentmate.jpg";
import milari_logo from "../../assets/images/Logo/milari.png";
// import easify_logo from "../../assets/images/Logo/easify.png";
import greenvalley_logo from "../../assets/images/Logo/greenvalley.png";
import operandi_logo from "../../assets/images/Logo/operandi.png";
import vegananatura_logo from "../../assets/images/Logo/vegana_natura.png";
import shlomit_logo from "../../assets/images/Logo/shlomit.png";
import ratnalinga_logo from "../../assets/images/Logo/ratnaling.png";
import cannabiz_logo from "../../assets/images/Logo/cannabiz.png";
import aamir_logo from "../../assets/images/Logo/amir.png";
// import digitalhp_logo from "../../assets/images/Logo/digital-np.png";
import ecom_logo from "../../assets/images/Logo/ecom.png";
import visapro_logo from "../../assets/images/Logo/visa.png";
import accidentmate_logo from "../../assets/images/Logo/logo.png";
import jobbterminalen from "../../assets/images/Logo/jobb.png";
import headline from "../../assets/images/Logo/headlinee.png";
import noafirm from "../../assets/images/Logo/noafirm.png";


// -------------------------------------------------------------------

// new images and logo

import RijbewijskeuringHolland from "../../assets/images/Country/RijbewijskeuringHolland.jpg"
import Officeel from "../../assets/images/Country/officeel.jpg";
import Dzukou from "../../assets/images/Country/Dzukou.jpg"
import onlinehuisverkoop from "../../assets/images/Country/onlinehu.jpg"
import immozins from "../../assets/images/Country/immozins.jpg"
import Hebammenpraxis from "../../assets/images/Country/hebammen.jpg"
import powerqr from "../../assets/images/Country/powerqr.jpg"
import degas from "../../assets/images/Country/degas.jpg"
import orange from "../../assets/images/Country/orange.jpg"
import geborgenhiet from "../../assets/images/Country/geborgenhiet.jpg"
import smarta from "../../assets/images/Country/smarta.jpg"
import shotokan from "../../assets/images/Country/shotokan.jpg"
import ayko from "../../assets/images/Country/ayko.jpg"
import reasearch from "../../assets/images/Country/reasearch.jpg"
import australian from "../../assets/images/Country/australian.jpg"
import RijbewijskeuringHolland_logo from "../../assets/images/Logo/logonew1black.jpg";
import Officeel_logo from "../../assets/images/Logo/Ribewij.png";
import Dzukou_logo from "../../assets/images/Logo/dzoku.png";
import onlinehuisverkooplogo from "../../assets/images/Logo/online.png";
import immozinslogo from "../../assets/images/Logo/immozin.png";
import Hebammenpraxislogo from "../../assets/images/Logo/hebammen.png";
import powerqrlogo from "../../assets/images/Logo/powerqr.png";
import degaslogo from "../../assets/images/Logo/degas.png";
import orangelogo from "../../assets/images/Logo/orange.png";
import geborglogo from "../../assets/images/Logo/geborg.png";
import samrtahuslogo from "../../assets/images/Logo/samrtahus.png";
import shotkanlogo from "../../assets/images/Logo/shotkan.png";
import aykologo from "../../assets/images/Logo/ayko.png";
import researchlogo from "../../assets/images/Logo/research.png";
import austrailialogo from "../../assets/images/Logo/austrailia (1).png";

import yippi from "../../assets/images/appDev/mob-2.jpg";
import minibar from "../../assets/images/appDev/mob-1.jpg";
import kivi from "../../assets/images/appDev/mob-3.jpg";
import pixise from "../../assets/images/appDev/mob-4.jpg";
import logo1 from "../../assets/images/appDev/logo1.png";
import logo2 from "../../assets/images/appDev/logo2.png";
import logo3 from "../../assets/images/appDev/logo3.png";
import logo4 from "../../assets/images/appDev/logo4.png";


const data = [
    {
        id: 1,
        name: 'Operandi',
        category: 'shopify',
        Link: 'https://operandigoods.com/',
        img: operandi,
        logo: operandi_logo,
        category2: 'e-commerce',
        desc: "Operandi is an Ecomm website, We worked on OPERANDI website design and development and maintainance. "
    }

    ,
    {
        id: 2,
        name: 'Vegana Natura ',
        category: 'shopify',
        Link: 'https://vegananatura.ch/',
        img: vegananatura,
        logo: vegananatura_logo,
        category2: 'e-commerce',
        desc: "Vegana Natura is an Ecomm website, Provided Maintainance. "
    },

    {
        id: 3,
        name: 'Green Valley',
        category: 'cms',
        Link: 'https://gvt.net/',
        img: greenvalley,
        logo: greenvalley_logo,
        category2: 'cms',
        desc: "Vegana Natura is an Ecomm website, We worked on cloning this website, SEO and maintainance."
    },

    {
        id: 4,
        name: 'Ratna Ling ',
        category: 'cms',
        Link: 'https://ratnaling.org/',
        img: ratnalinga,
        logo: ratnalinga_logo,
        category2: 'cms',
        desc: "Ratna Ling is Blog website is built in PHP/ Wordpress. Provide Business Compliance Services."

    },

    {
        id: 5,
        name: 'Milari Organics',
        category: 'shopify',
        Link: 'https://milariorganics.com.au/',
        img: milari,
        logo: milari_logo,
        category2: 'e-commerce',
        desc: "Milari Organics is an e-commerce website, we handle the development of this website and SEO also. "
    },


    // {
    //     id:6,
    //     name:'Easify',
    //     category:'php',
    //     Link:'https://www.easifyy.com/',
    //     img: easify,
    //     logo: easify_logo,
    //     category2:'e-commerce',
    //     desc:"Easify, A marketplace-based website is built in Cake PHP. Provide Business Compliance Services."
    // }

    ,
    {
        id: 7,
        name: 'Shlomit ',
        category: 'cms',
        Link: 'https://shlomit.ewp.co.il/',
        img: shlomit,
        logo: shlomit_logo,
        category2: 'e-commerce',
        desc: "Shlomit is an Ecommerce website, We provided services like website creation and maintainance"
    },
    {
        id: 8,
        name: 'Cannabiz ',
        category: 'cms',
        Link: 'https://cannabiz.co.il/',
        img: cannabiz,
        logo: cannabiz_logo,
        category2: 'e-commerce',
        desc: "Cannabiz Ecommerce website is built in Wordpress. Provide Maintainance and Business Compliance Services."

    },
    {
        id: 9,
        name: 'Amir ',
        category: 'cms',
        Link: 'https://amir.ewp.co.il/',
        img: aamir,
        logo: aamir_logo,
        category2: 'cms',
        desc: "Amir Ecommerce website is built in Wordpress, Design Implemented from figma. Provide Maintainance and Business Compliance Services."

    },
    , {
        id: 10,
        name: 'Ecom ',
        category: 'cms',
        Link: 'https://ecom.ewp.co.il/',
        img: ecom,
        logo: ecom_logo,
        category2: 'cms',
        desc: "Ecom Ecommerce website is built in Wordpress, Design Implemented from figma. Provide Maintainance and Business Compliance Services."
    }
    , {
        id: 11,
        name: 'Visa Pro ',
        category: 'cms',
        Link: 'https://esta-center.co.il/',
        img: visapro,
        logo: visapro_logo,
        category2: 'cms',
        desc: "Implemented Visa form to collect data in Visa Pro, Provided Maintainance."
    },
    {
        id: 12,
        name: 'Accident-Mate ',
        category: 'react',
        Link: 'https://dev.accidentmate.com/',
        img: accidentmate,
        logo: accidentmate_logo,
        category2: 'ui/ux',
        desc: "Accident-Mate is services listing website and it is built in Reactjs. Provide Business Compliance Services, Maintainance and SEO."
    },


    {
        id: 13,
        name: 'Rijbewijskeuring Holland ',
        category: 'cms',
        Link: 'https://rijbewijskeuringholland.nl/',
        img: RijbewijskeuringHolland,
        logo: RijbewijskeuringHolland_logo,
        category2: 'ui/ux',
        desc: "Rijbewijskeuring Holland is Blog website and its built in PHP/ Wordpress. Provide Business Compliance Services."
    },
    {
        id: 14,
        name: 'Rijbewijskeuring Officieel ',
        category: 'cms',
        Link: 'https://www.rijbewijskeuringofficieel.nl/',
        img: Officeel,
        logo: Officeel_logo,
        category2: 'ui/ux',
        desc: "Rijbewijskeuring Officieel Blog website is built in PHP/ Wordpress. Provide Business Compliance Services."
    }
    ,
    {
        id: 15,
        name: 'Dzukou ',
        category: 'shopify',
        Link: 'https://dzukou.com/en-in',
        img: Dzukou,
        logo: Dzukou_logo,
        category2: 'cms',
        desc: "Dzukou Ecommerce website is built in Wordpress. Provide Business Compliance Services and Maintaiance."
    }
    ,
    {
        id: 16,
        name: 'Online-hu-is-verkoop ',
        category: 'php',
        Link: 'https://onlinehuisverkoop.nl/',
        img: onlinehuisverkoop,
        logo: onlinehuisverkooplogo,
        category2: 'ui/ux',
        desc: "Online-hu-is-verkoop Blog website is built in PHP/ Wordpress. Provide Business Compliance Services."
    }
    ,
    {
        id: 17,
        name: 'Immozins',
        category: 'cms',
        Link: 'https://immozins.ch/',
        img: immozins,
        logo: immozinslogo,
        category2: 'wordpress',
        desc: "Immozins Blog website is built in PHP/ Wordpress. Provide Business Compliance Services."
    }
    ,
    {
        id: 18,
        name: 'Hebammenpraxis-Dietikon',
        category: 'cms',
        Link: 'https://hebammenpraxis-dietikon.ch/',
        img: Hebammenpraxis,
        logo: Hebammenpraxislogo,
        category2: 'ui/ux',
        desc: "Hebammenpraxis-Dietikon Blog website is built in PHP/ Wordpress. Provide Business Compliance Services."
    }
    ,
    {
        id: 19,
        name: 'Power-QR ',
        category: 'php',
        Link: 'http://powerqr-onagency.ch/#',
        img: powerqr,
        logo: powerqrlogo,
        category2: 'ui/ux',
        desc: "Power-QR, A QR website its built in CorePHP, Created QR Functionality. Provide Business Compliance Services."
    }
    ,
    {
        id: 20,
        name: 'Degas ',
        category: 'cms',
        Link: 'https://www.degas.ch/',
        img: degas,
        logo: degaslogo,
        category2: 'ui/ux',
        desc: "Degas Blog website is built in PHP/ Wordpress. Provide Business Compliance Services."
    }

    ,
    {
        id: 21,
        name: 'Smartahus ',
        category: 'ecom',
        Link: 'https://smartahus.se/',
        img: smarta,
        logo: samrtahuslogo,
        category2: 'cms',
        desc: "Smartahus Warehouse/Marketplace website is built in Cake PHP. Provide Business Compliance Services, SEO and Maintainance ."
    }

    ,
    {
        id: 22,
        name: 'Ayko',
        category: 'cms',
        Link: 'https://aykoagency.com/',
        img: ayko,
        logo: aykologo,
        category2: 'wordpress',
        desc: "Ayko Blog website is built in PHP/ Wordpress. Provide Business Compliance Services."
    }
    ,
    // {
    //     id:23,
    //     name:'Pi-research ',
    //     category:'php',
    //     Link: 'https://www.thepiresearch.com/',
    //     img: reasearch,
    //     logo: researchlogo,
    //     category2:'ui/ux',
    //     desc:"Provided Maintainance, SEO services and other Business Compliance Services"
    // }
    ,
    {
        id: 24,
        name: 'Australian ',
        category: 'php',
        Link: 'https://www.passivhausassociation.com.au/',
        img: australian,
        logo: austrailialogo,
        category2: 'ui/ux',
        desc: "Australian marketplace-based website is built in Cake PHP. Provide SEO and Business Compliance Services."
    },
    {
        id: 25,
        name: 'Yippi',
        category: 'app',
        Link: 'http://yippiweb.com/',
        img: yippi,
        logo: logo1,
        category2: 'e-commerce',
        desc: "Yippi is an chatting app, we made this social app for chatting "
    }

    ,
    {
        id: 26,
        name: 'minibar ',
        category: 'app',
        Link: 'https://minibardelivery.com/',
        img: minibar,
        logo: logo2,
        category2: 'e-commerce',
        desc: "Minibar is an Wine, Liquor, and Beer delivery app"
    }
    ,
    {
        id: 27,
        name: 'Kivi Vpn ',
        category: 'app',
        Link: 'https://apps.apple.com/in/app/kivi-vpn-fast-secure-proxy/id1613664487',
        img: kivi,
        logo: logo3,
        category2: 'e-commerce',
        desc: "Kivi VPN is fast and secure VPN proxy that hides your true IP address and secures your privacy."
    }
    ,
    // {
    //     id:28,
    //     name:'Pixise ',
    //     category:'app',
    //     Link: 'https://apps.apple.com/in/app/pixise-photo-editing-app/id1588624461',
    //     img: pixise,
    //     logo: logo4,
    //     category2:'e-commerce',
    //     desc:"Pixise is a photo editing app which helps you create amazing photos for social media."
    // }
    ,
    {
        id: 29,
        name: 'Jobbterminalen ',
        category: 'react',
        Link: 'https://jobbterminalen.se',
        img: pixise,
        logo: jobbterminalen,
        category2: 'employment',
        desc: "Jobbterminalen is a platform which connect you with opportunities that align with your aspirations and skills."
    },
    {
        id: 30,
        name: 'NOA Firm ',
        category: 'cms',
        Link: 'https://www.noafirm.com/',
        img: pixise,
        logo: noafirm,
        category2: 'wordpress',
        desc: "Newsheadline is a platform to revolutionize online marketing for dental and medical practices."
    },
    {
        id: 31,
        name: 'Newsheadline ',
        category: 'cms',
        Link: 'https://newsheadline.co.in',
        img: pixise,
        logo: headline,
        category2: 'wordpress',
        desc: "Newsheadline is a platform were you get updates about your surrounding and the outside world."
    }

]

export default data;